<template>
  <div class="main-layout-transparent mdl-layout mdl-js-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'main-layout'
}
</script>



// WEBPACK FOOTER //
// UiLayout.vue?413846a2